import { RichTextRenderer } from "@caisy/league";
import { FC } from "react";
import { SRegisterFormRichText } from "./styles/SRegisterFormRichText";

interface IRegisterFormRichText {
  node: any;
  alignCenter?: boolean;
}

export const RegisterFormRichText: FC<IRegisterFormRichText> = ({ node, alignCenter }) => {
  return (
    <SRegisterFormRichText alignCenter={alignCenter}>
      <RichTextRenderer node={node} />
    </SRegisterFormRichText>
  );
};
